import React, { useEffect, useContext, useRef } from "react";
import SkeletonState from "./SkeletonState";
import ForumMoreButton from "./ForumMoreButton";
import ForumLikeButton from "./ForumLikeButton";
import firebase from "../../firebase";
import { AuthContext } from "../../auth";
import DoctorBadge from "../DoctorBadge";

import { makeStyles } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Container from "@material-ui/core/Container";
import ReplyIcon from "@material-ui/icons/Reply";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  rootComment: {
    maxWidth: "auto",
    marginBottom: 8,
    //borderLeft: "4px solid grey",
  },
  contentComment: {
    paddingTop: 4,
    paddingBottom: 0,
    paddingLeft: 16,
    paddingRight: 16,
  },
  headerComment: {
    paddingTop: 10,
    paddingBottom: 0,
    paddingLeft: 16,
    paddingRight: 16,
  },
  actionsComment: {
    paddingTop: 0,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
  },
  actionsButton: {
    marginLeft: "auto",
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
}));

const ForumComments = (props) => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const _isMounted = useRef(true);
  const [collapse, setCollapse] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [allComments, setAllComments] = React.useState([]);
  const [hasFetched, setHasFetched] = React.useState(false);

  useEffect(() => {
    if (props.collapseComments !== collapse) {
      setCollapse(props.collapseComments);
    }
  }, [props.collapseComments, collapse]);

  useEffect(() => {
    if (collapse && !hasFetched) {
      fetchComments(props.id);
    } else {
      return;
    }
  }, [collapse]);

  useEffect(() => {
    const listenUpdates = firebase
      .database()
      .ref("comments/" + props.id)
      .orderByKey();

    if (hasFetched && _isMounted) {
      listenUpdates.on("child_added", (data) => {
        if (isIncluded(allComments, data.key)) {
          return;
        } else {
          let clonedComments = [...allComments];
          const date = new Date(data.val().commentDate).toLocaleDateString();
          const time = new Date(data.val().commentDate).toLocaleTimeString();
          clonedComments.push({
            id: data.key,
            comment: data.val().comment,
            commentTimestamp: data.val().commentDate,
            commentDate: date + " at " + time,
            commentEdited: data.val().commentEdited,
            commentName: data.val().commentName,
            commentUserID: data.val().commentUserID,
            fromPost: data.val().fromPost,
            replyTo: data.val().replyTo ? data.val().replyTo : null,
            voters: data.val().voters ? data.val().voters : {},
            votes: data.val().votes ? data.val().votes : 0,
          });
          updateComments(clonedComments);
        }
      });
      listenUpdates.on("child_changed", (data) => {
        let commentIndex = 0;
        allComments.forEach((object, index) => {
          if (object.id === data.key) commentIndex = index;
        });
        let clonedComments = [...allComments];
        const date = new Date(data.val().commentDate).toLocaleDateString();
        const time = new Date(data.val().commentDate).toLocaleTimeString();
        clonedComments.splice(commentIndex, 1, {
          id: data.key,
          comment: data.val().comment,
          commentTimestamp: data.val().commentDate,
          commentDate: date + " at " + time,
          commentEdited: data.val().commentEdited,
          commentName: data.val().commentName,
          commentUserID: data.val().commentUserID,
          fromPost: data.val().fromPost,
          replyTo: data.val().replyTo ? data.val().replyTo : null,
          voters: data.val().voters ? data.val().voters : {},
          votes: data.val().votes ? data.val().votes : 0,
        });
        updateComments(clonedComments);
      });
      listenUpdates.on("child_removed", (data) => {
        let commentIndex = 0;
        allComments.forEach((object, index) => {
          if (object.id === data.key) commentIndex = index;
        });
        let clonedComments = [...allComments];
        clonedComments.splice(commentIndex, 1);
        updateComments(clonedComments);
      });
    }
    return () => {
      listenUpdates.off();
      _isMounted.current = false;
    };
  }, [hasFetched, allComments]);

  const isIncluded = (object, key) => {
    let matchFound = null;
    object.forEach((data) => {
      if (data.id === key) {
        matchFound = true;
      } else {
        return;
      }
    });
    return matchFound;
  };

  const handleReply = (event, buttonID, id, name, isComment) => {
    props.reply(event, buttonID, id, name, isComment);
  };

  const updateComments = (newComments) => {
    setAllComments(newComments);
  };

  const fetchComments = async (id) => {
    setLoading(true);
    let initialComments = [];
    try {
      const subscribeComments = firebase
        .database()
        .ref("comments/" + id)
        .orderByKey();

      let fetchedComments = await subscribeComments.once("value");
      fetchedComments.forEach((data) => {
        const date = new Date(data.val().commentDate).toLocaleDateString();
        const time = new Date(data.val().commentDate).toLocaleTimeString();
        initialComments.push({
          id: data.key,
          comment: data.val().comment,
          commentTimestamp: data.val().commentDate,
          commentDate: date + " at " + time,
          commentEdited: data.val().commentEdited,
          commentName: data.val().commentName,
          commentUserID: data.val().commentUserID,
          fromPost: data.val().fromPost,
          replyTo: data.val().replyTo ? data.val().replyTo : null,
          voters: data.val().voters ? data.val().voters : {},
          votes: data.val().votes ? data.val().votes : 0,
        });
      });
      updateComments(initialComments);
    } catch (error) {
      //handle error
    } finally {
      setTimeout(() => {
        setHasFetched(true);
        setLoading(false);
      }, 1000);
    }
  };

  const mapComments = (comments) => {
    if (Array.isArray(comments) && comments.length) {
      return (
        <Container>
          {comments.map((singleComment) => (
            <Card
              elevation={0}
              className={classes.rootComment}
              key={singleComment.id}
            >
              <CardHeader
                className={classes.headerComment}
                title={
                  <Typography component="div">
                    <Box
                      fontSize={14}
                      display="inline"
                      fontWeight="fontWeightBold"
                      className={classes.secondaryText}
                    >
                      {singleComment.commentName}
                      <DoctorBadge
                        type="SMALL"
                        id={singleComment.commentUserID}
                      />
                      &nbsp;
                    </Box>
                    <Box
                      fontSize={14}
                      display="inline"
                      fontWeight={460}
                      className={classes.secondaryText}
                    >
                      ·&nbsp;{singleComment.commentDate}
                    </Box>
                    {singleComment.commentEdited ? (
                      <Box
                        fontSize={14}
                        display="inline"
                        fontWeight={400}
                        letterSpacing={0.4}
                      >
                        &nbsp;·&nbsp;edited
                      </Box>
                    ) : null}
                  </Typography>
                }
              />
              <CardContent className={classes.contentComment}>
                <Typography component="div">
                  {singleComment.replyTo ? (
                    <Box
                      display="inline"
                      letterSpacing={0.5}
                      fontSize={16}
                      fontWeight={600}
                    >
                      {singleComment.replyTo}&nbsp;
                    </Box>
                  ) : null}
                  <Box
                    display="inline"
                    whiteSpace="pre-wrap"
                    letterSpacing={0.7}
                    fontSize={16}
                    fontWeight={400}
                  >
                    {singleComment.comment}
                  </Box>
                </Typography>
              </CardContent>
              <CardActions className={classes.actionsComment}>
                <span className={classes.actionsButton}>
                  <ForumLikeButton {...singleComment} />
                  {currentUser ? (
                    <Tooltip
                      title="Reply"
                      enterDelay={300}
                      leaveDelay={200}
                      enterNextDelay={300}
                    >
                      <span>
                        <IconButton
                          id={singleComment.id}
                          aria-label="reply"
                          size="small"
                          onClick={(e) =>
                            handleReply(
                              e,
                              singleComment.id,
                              props.id,
                              "@" + singleComment.commentName,
                              false
                            )
                          }
                        >
                          <ReplyIcon color="secondary" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  ) : null}
                  {singleComment.commentUserID === (currentUser || {}).uid &&
                  _isMounted ? (
                    <ForumMoreButton {...singleComment} />
                  ) : null}
                </span>
              </CardActions>
              <Divider variant="middle" />
            </Card>
          ))}
        </Container>
      );
    } else {
      return (
        <Typography component="div">
          <Box textAlign="center" fontWeight="fontWeightLight">
            No comments yet.&nbsp;
            <span role="img" aria-label="search-face">
              🧐
            </span>
          </Box>
        </Typography>
      );
    }
  };

  let commentContent = null;
  if (loading) {
    commentContent = <SkeletonState forComment={true} />;
  } else {
    commentContent = mapComments(allComments);
  }

  return (
    <div key={props.id}>
      <Collapse in={collapse}>{commentContent}</Collapse>
    </div>
  );
};

export default ForumComments;
